export default __webpack_public_path__ + "static/media/Close.113698b1.svg";